var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var d3 = {
  ...require("d3-array/dist/d3-array.min"),
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-geo/dist/d3-geo.min")
};

var { COLORS, classify, makeTranslate, formatStyle, wrapText } = require("./lib/helpers");
var { isMobile } = require("./lib/breakpoints");

var pymChild = null;
var chartWidth;
var chartHeight;
var chartWrapper;
var chartElement;

var topojson = require("topojson-client/dist/topojson-client.min");
var geoData = require("./data/countries.json");
var highlightData = DATA;
var topic = TOPIC;

// console.log(geoData);

var onWindowLoaded = function() {
  console.clear();

  // console.log(countriesData);
  formatData()
  render();
  window.addEventListener("resize", render);

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
}

var formatData = function() {
  highlightData = highlightData.filter(d => d[topic] == 1);
}

var render = function() {
  // console.log("yeet")
  var container = "#map-container";
  var element = document.querySelector(container);
  var width = element.offsetWidth;

  renderMap({
    container,
    width,
    data: highlightData
  })

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

var renderMap = function(config) {
  var aspectWidth = isMobile.matches ? 4 : 16;
  var aspectHeight = isMobile.matches ? 3 : 7;

  var margins = {
    top: 0,
    right: 0,
    bottom: 10,
    left: 0
  };

  // Calculate actual chart dimensions
  chartWidth = config.width - margins.left - margins.right;
  chartHeight =
    Math.ceil((config.width * aspectHeight) / aspectWidth) -
    margins.top -
    margins.bottom;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  // Create projection
  var projection = d3.geoNaturalEarth1()
    .translate([chartWidth / 2, chartHeight / 2]) // translate to center of screen
    .scale(config.width / 1.85 / Math.PI)
    .center([15, 20]);

  var path = d3.geoPath().projection(projection);

  // Create the root SVG element.
  chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // clean geodata
  var countriesData = topojson.feature(geoData,geoData.objects["countries"]);

  // check if country is highlighted
  var checkHighlight = function(country, topic) {
    // console.log(config.data, Array.isArray(config.data))
    var matching = config.data.some(d => d.place === country);

    if (matching) {
      return true;
    }
    return false;
  }

  // add countries
  var countries = chartElement
    .selectAll(".country")
    .data(countriesData.features)
    .enter()
    .append("path")
    .attr("class", "country")
    .attr("geoid", d=>`${d.properties["npr_name"]}`)
    .attr("d", path)
    .attr("class", function(d) {
      if (checkHighlight(d.properties["npr_name"], topic)) {
        return "highlight" + " " + TOPIC;
      }

      if (d.properties["npr_name"] == "Ukraine") {
        return "ukraine-highlight";
      }
      return "no-highlight";
    });
}

/*
 * Initially load the graphic
 * (NB: Use window.load to ensure all images have loaded)
 */
window.onload = onWindowLoaded;
